// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinkPresentationProps } from "@insite/mobius/Link";
import AddToList from "@sc/XDL/Icons/AddToList";
import Plus from "@sc/XDL/Icons/Plus";
import Remove from "@sc/XDL/Icons/Remove";
import SaveOrder from "@sc/XDL/Icons/SaveOrder";
import { createLinkIconStyles } from "@sc/XDL/Utilities";
import { css } from "styled-components";

interface CartPageStyles {
    cartActions?: {
        saveOrderLink?: LinkPresentationProps;
        addAllToListClickable?: LinkPresentationProps;
        removeAll?: LinkPresentationProps;
    };
}
const linkIconStyles: LinkPresentationProps = {
    typographyProps: {
        size: 12,
    },
    icon: {
        iconProps: {
            size: 11,
        },
        position: "left",
    },
};

const cartPageStyles: CartPageStyles = {
    cartActions: {
        saveOrderLink: {
            ...createLinkIconStyles(SaveOrder, {
                ...linkIconStyles,
                icon: {
                    iconProps: {
                        size: 14,
                    },
                },
            }),
        },
        addAllToListClickable: {
            ...createLinkIconStyles(AddToList, linkIconStyles),
        },
        removeAll: {
            ...createLinkIconStyles(Remove),
        },
    },
};

export default cartPageStyles;
